import { legacyRoot } from '~/modules/legacyRuntime.js';

const DEFAULT_TRANSLATIONS = {
  no_songs_available: {
    de: 'Leider keine passenden Songs gefunden. Bitte passen Sie die Suchkriterien an.',
    en: 'No matching songs found'
  }
};

export function resolveLegacyLocale(locale) {
  if (typeof locale === 'string' && locale.length > 0) {
    return locale.toLowerCase().startsWith('de') ? 'de' : 'en';
  }

  const root = legacyRoot();
  const bodyLocale = root.document && root.document.body && root.document.body.dataset
    ? root.document.body.dataset.lang
    : '';
  if (typeof bodyLocale === 'string' && bodyLocale.length > 0) {
    return bodyLocale.toLowerCase().startsWith('de') ? 'de' : 'en';
  }

  const globalLocale = root.I18n && typeof root.I18n.locale === 'string' ? root.I18n.locale : '';
  if (globalLocale.length > 0) {
    return globalLocale.toLowerCase().startsWith('de') ? 'de' : 'en';
  }

  return 'en';
}

export function translateLegacyText(key, options = {}) {
  const i18n = options.i18n || {};

  if (typeof i18n[key] === 'string' && i18n[key].length > 0) {
    return i18n[key];
  }

  const locale = resolveLegacyLocale(options.locale);
  return DEFAULT_TRANSLATIONS[key] && DEFAULT_TRANSLATIONS[key][locale] ? DEFAULT_TRANSLATIONS[key][locale] : key;
}
